import styled from "@emotion/styled";
import { Link } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

import { Icon } from "@components/Icon";
import { media } from "@themes/breakpoints";
import { theme } from "@themes/themes";

import DiscordIcon from "@assets/social/discord.svg?react";
import GithubIcon from "@assets/social/github.svg?react";
import XIcon from "@assets/social/x.svg?react";

import { FooterConnectionLatency } from "./FooterConnectionLatency";

const links = [
  {
    link: "https://github.com/ekidenfi",
    label: "GitHub repository ekidenfi (opens in new tab)",
    icon: <GithubIcon />,
  },
  {
    link: "https://x.com/ekidenfi",
    label: "X (Twitter) ekidenfi (opens in new tab)",
    icon: <XIcon />,
  },
  {
    link: "https://discord.com/invite/37682NeRb3",
    label: "Discord ekidenfi (opens in new tab)",
    icon: <DiscordIcon />,
  },
];

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <FooterRoot>
      <LinkEkiden aria-current="page" href="/" rel="home" size="1">
        ekiden.fi
      </LinkEkiden>
      {links.map((el) => (
        <StyleIconLink key={el.link} aria-label={el.label} href={el.link} rel="noopener noreferrer" target="_blank">
          {el.icon}
        </StyleIconLink>
      ))}
      <Spacer />
      <FooterConnectionLatency />
      <DocsLink href="https://docs.ekiden.fi/" rel="noopener noreferrer" target="_blank">
        <Icon color="accent-contrast" icon="ri-book-open-line" size={12} />
        {t("menu.docs")}
      </DocsLink>
    </FooterRoot>
  );
};

const FooterRoot = styled.footer`
  box-sizing: border-box;
  align-self: stretch;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 48px;
  background: ${theme.color("gray-2")};
  border-top: 1px solid ${theme.color("gray-5")};

  ${media.mobile} {
    gap: 8px;
    padding-inline: 8px;
  }
`;

const LinkEkiden = styled(Link)`
  flex-shrink: 0;
  color: ${theme.color("accent-contrast")};
  &:hover {
    color: ${theme.color("accent-9")};
    cursor: pointer;
  }
`;

const StyleIconLink = styled(Link)`
  display: flex;
  flex-shrink: 0;

  &:hover svg path {
    fill: ${theme.color("accent-9")};
  }
`;

const Spacer = styled.div`
  flex: 1;
  min-width: 0;
`;

const DocsLink = styled(Link)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
  padding: 0px 2px;
  color: ${theme.color("accent-contrast")};
  font-size: 12px;

  &:hover {
    color: ${theme.color("accent-9")};
  }
`;
